import * as serializers from '../../serializers'

// eslint-disable-next-line import/prefer-default-export
export const acceptTerm = serializers.application
